/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkActivationResultItemDTO
 */
export interface BulkActivationResultItemDTO {
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'status': BulkActivationResultItemDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'endDate'?: string;
    /**
     * warning key for a partial success (e.g. the result was adjusted / a date was capped)
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'warning'?: BulkActivationResultItemDTOWarningEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetMail'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetEmployeeNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetDepartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'targetExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkActivationResultItemDTO
     */
    'errorMessage'?: string;
}

export const BulkActivationResultItemDTOStatusEnum = {
    Success: 'SUCCESS',
    Adjustment: 'ADJUSTMENT',
    Blocked: 'BLOCKED',
    Error: 'ERROR'
} as const;

export type BulkActivationResultItemDTOStatusEnum = typeof BulkActivationResultItemDTOStatusEnum[keyof typeof BulkActivationResultItemDTOStatusEnum];
export const BulkActivationResultItemDTOWarningEnum = {
    TerminationDateCapped: 'terminationDateCapped'
} as const;

export type BulkActivationResultItemDTOWarningEnum = typeof BulkActivationResultItemDTOWarningEnum[keyof typeof BulkActivationResultItemDTOWarningEnum];


